import { useStructuredNodeContext } from "components/project/layers/components/layer-managers/project-layer-tree/node-manager/context/StructuredNodeContext";
import { cancelNodeChanges } from "components/project/layers/components/layer-managers/project-layer-tree/node-manager/context/reducer";
import { useProjectDispatch } from "components/project/projects/context";

export type UseCancelShapefileChangesReturn = {
  mutate: (e: React.SyntheticEvent) => void;
};

export function useCancelShapefileChanges() {
  const [, nodeDispatch] = useStructuredNodeContext();
  const projectDispatch = useProjectDispatch();

  const mutate = (e) => {
    e.stopPropagation();
    e.preventDefault();

    cancelNodeChanges(nodeDispatch, (isDraggable) =>
      projectDispatch({ payload: { isTreeDraggable: isDraggable } })
    );
  };

  return { mutate };
}
